module.exports = __webpack_public_path__ + "img/arrow-down.3c32bca0.svg";